import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53fcba93&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fcba93')) {
      api.createRecord('53fcba93', component.options)
    } else {
      api.reload('53fcba93', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=53fcba93&", function () {
      api.rerender('53fcba93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/asideComponent/index.vue"
export default component.exports